import React from "react"
import PropTypes from "prop-types"
import { Flex, Switch, Tooltip } from "antd"
import { useTranslation } from "react-i18next"
import { DeleteOutlined, EditOutlined } from "@ant-design/icons"
import { spacings } from "themes/variables"
import IconWithBg from "ui/IconWithBg"
import { Text } from "ui/Typography"
import styles from "./TicketTypeRow.module.css"

export const TicketTypeRow = ({ ticket, isLast, isLastEnabled, onToggle, onEdit, onDelete }) => {
  const { t } = useTranslation()

  return (
    <Flex align="center" gap={16} className={styles.ticketRow}>
      <Tooltip title={isLast || isLastEnabled ? t("experiences.ticket_type.last_active_tooltip") : undefined}>
        {/* span keeps the tooltip working — disabled switches swallow mouse events */}
        <span>
          <Switch checked={ticket.enabled} disabled={isLast || isLastEnabled} onChange={(checked) => onToggle(ticket.id, checked)} />
        </span>
      </Tooltip>
      <Text fw={500} className={styles.ticketTitle}>
        {ticket.title}
      </Text>
      <Text className={styles.ticketDescription}>{ticket.description}</Text>
      {ticket.maxCapacity != null && (
        <Text className={styles.ticketDescription}>{t("experiences.ticket_type.max_display", { count: ticket.maxCapacity })}</Text>
      )}
      <Flex gap={spacings.XS} className="ml-auto">
        <IconWithBg icon={<EditOutlined />} onClick={() => onEdit(ticket)} />
        <Tooltip title={isLast ? t("experiences.ticket_type.last_required_tooltip") : undefined}>
          <IconWithBg icon={<DeleteOutlined />} onClick={isLast ? undefined : () => onDelete(ticket.id)} disabled={isLast} />
        </Tooltip>
      </Flex>
    </Flex>
  )
}

TicketTypeRow.propTypes = {
  ticket: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    enabled: PropTypes.bool.isRequired,
    maxCapacity: PropTypes.number
  }).isRequired,
  isLast: PropTypes.bool,
  isLastEnabled: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
}

TicketTypeRow.defaultProps = {
  isLast: false,
  isLastEnabled: false
}
